
<template>


<div v-if="iframeUrl" class="iframe-block">
    <iframe
     
      ref="iframe"
      class="iframe-block-frame"
      :src="iframeUrl"
      :style="{ height: iframeHeight + 'px' }"
      sandbox="allow-scripts allow-same-origin allow-forms"
      referrerpolicy="no-referrer"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "IframeBlock",
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // Default height; will be updated if the embedded page cooperates via postMessage
      iframeHeight: 600,
      allowedOrigin: null
    }
  },
  computed: {
    iframeUrl() {
      return this.getLocalizedUrl()
    }
  },
  watch: {
    iframeUrl(newUrl) {
      this.updateAllowedOrigin(newUrl)
    }
  },
  mounted() {
    // Derive the allowed origin from the iframe URL we render.
    this.updateAllowedOrigin(this.iframeUrl)
    // Listen for resize messages from the embedded page
    window.addEventListener('message', this.handleIframeMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleIframeMessage)
  },
  methods: {
    getLocalizedUrl() {
      const locale = this.$i18n?.locale
      const fieldData = this.block?.data?.["url"]

      if (!fieldData) {
        return null
      }

      // Multilingual object case
      if (typeof fieldData === "object" && fieldData !== null) {
        // 1) Try the current locale, if available
        if (locale && fieldData[locale]) {
          return fieldData[locale]
        }

        // // 2) Fallback to "en" if present
        // if (fieldData["en"]) {
        //   return fieldData["en"]
        // }
        //
        // // 3) Fallback to the first available non-empty value
        // const firstValue = Object.values(fieldData).find(v => !!v)
        // return firstValue || null
      }

      return null
    },
    updateAllowedOrigin(url) {
      if (!url) {
        this.allowedOrigin = null
        return
      }
      try {
        const parsed = new URL(url)
        this.allowedOrigin = parsed.origin
      } catch (e) {
        this.allowedOrigin = null
      }
    },
    handleIframeMessage(event) {
      // Only accept messages from the origin of the currently embedded URL
      if (!this.allowedOrigin || event.origin !== this.allowedOrigin) return

      const data = event.data
      if (!data || typeof data !== "object") return

      // Generic resize contract:
      if (data.type === "IFRAME_RESIZE" && typeof data.height === "number") {
        this.iframeHeight = Math.max(100, data.height)
      }
    }
  }
}
</script>

<style scoped>
.iframe-block {
  width: 100%;
}

.iframe-block-frame {
  width: 100%;
  border: 0;
  display: block;
}
</style>
